import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { EventService } from '@services/event.service';
import { AuthService } from '@services/auth.service';

/** Путь страховки выхода: с неё вкладку перезагружать нельзя — она рассылает сигнал остальным. */
const FRONTCHANNEL_LOGOUT_PATH = '/frontchannel-logout';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.html',
    styleUrl: './app.scss',
})
export class App implements OnInit, OnDestroy {
    private readonly eventService = inject(EventService);
    private readonly auth = inject(AuthService);

    private readonly subscriptions = [this.eventService.on('exit', () => this.auth.logout())];

    ngOnInit() {
        // Эта вкладка только что вышла: возвращаемся с end-session Keycloak, значит SSO-сессия
        // уже уничтожена и остальные вкладки можно оповещать — перезагрузятся и уйдут на вход,
        // а не вернутся в приложение. Если выход был в соседней вкладке, метки здесь нет.
        this.auth.completeLogout();

        // В другой вкладке вышли: гасим токены и перезагружаемся — authGuard уведёт на вход
        // через Keycloak с возвратом в тот же раздел.
        this.subscriptions.push(
            this.auth.remoteLogout$.subscribe(() => {
                this.auth.logoffLocal();

                if (window.location.pathname !== FRONTCHANNEL_LOGOUT_PATH) {
                    window.location.reload();
                }
            }),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
}
